define('home/views/ActivityCardTrendingView',[
    'underscore',
    'backbone-marionette',
    'home/mixins/withReasonOld',
    'home/mixins/withSubviews',

    'home/views/ActivityFooterTrendingView',

    'home/templates/activityCardTrending',
], function (
    _,
    Marionette,
    withReason,
    withSubviews,

    ActivityFooterTrendingView,

    activityCardTrendingTemplate
) {
    'use strict';

    var parent = Marionette.ItemView;


    var ActivityCardTrendingView = parent.extend({
        template: activityCardTrendingTemplate,
        templateHelpers: function () {
            var forumFavicon = this.model.thread.forum.get('favicon') &&
                this.model.thread.forum.get('favicon').cache;

            var helpers = {};

            return _.extend(helpers, {
                commenter: this.model.thread.getMostRecentCommenter(),
                target: this.model.activities[0].target.toJSON(),
                discussionRoute: this.model.thread.getDiscussionRoute(),
                threadDescriptionHTML: this.model.thread.getDefaultDescription(),

                // Hide default favicons
                hideForumFavicon: !forumFavicon || /favicon-default/.test(forumFavicon),
            });
        },

        initialize: function () {
            this.listenTo(this.model.thread, 'change:content', this.render);
        },

        regions: {
            footerRegion: '[data-role=footer]',
        },

        onRender: function () {
            this.activateRegion(this.footerRegion, this.createFooterView);
        },

        createFooterView: function () {
            return new ActivityFooterTrendingView({
                el: this.footerRegion.el,
                model: this.model,
            });
        },
    });


    var proto = ActivityCardTrendingView.prototype;
    withReason.call(proto);
    withSubviews.call(proto);

    return ActivityCardTrendingView;
});

